(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GameInit", [], factory);
	else if(typeof exports === 'object')
		exports["GameInit"] = factory();
	else
		root["GameInit"] = factory();
})(window, function() {
return 